export interface RouteStop {
  id: string;
  address: string;
  city: string;
  priority: 'high' | 'medium' | 'low';
  timeWindow: string;
  packages: number;
  lat: number;
  lng: number;
  status: 'pending' | 'completed' | 'current';
}

export interface OptimizedRoute {
  id: string;
  name: string;
  stops: RouteStop[];
  totalDistance: number;
  estimatedTime: number;
  fuelCost: number;
  optimized: boolean;
  driver: string;
  vehicle: string;
}

export const OPTIMIZED_ROUTES: OptimizedRoute[] = [
  {
    id: 'RT-001',
    name: 'NYC Downtown Express',
    driver: 'Carlos Rivera',
    vehicle: 'Van #V-2291',
    totalDistance: 187,
    estimatedTime: 240,
    fuelCost: 42.50,
    optimized: true,
    stops: [
      { id: 'S1', address: '350 5th Ave', city: 'New York, NY', priority: 'high', timeWindow: '09:00-10:00', packages: 3, lat: 40.7484, lng: -73.9967, status: 'completed' },
      { id: 'S2', address: '20 W 34th St', city: 'New York, NY', priority: 'medium', timeWindow: '10:00-11:00', packages: 1, lat: 40.7490, lng: -73.9882, status: 'completed' },
      { id: 'S3', address: '1 World Trade Center', city: 'New York, NY', priority: 'high', timeWindow: '11:00-12:00', packages: 5, lat: 40.7127, lng: -74.0134, status: 'current' },
      { id: 'S4', address: '60 Wall St', city: 'New York, NY', priority: 'low', timeWindow: '13:00-14:00', packages: 2, lat: 40.7069, lng: -74.0089, status: 'pending' },
      { id: 'S5', address: '11 Wall St', city: 'New York, NY', priority: 'medium', timeWindow: '14:00-15:00', packages: 4, lat: 40.7074, lng: -74.0113, status: 'pending' },
    ],
  },
  {
    id: 'RT-002',
    name: 'LA Westside Circuit',
    driver: 'Anna Torres',
    vehicle: 'Truck #T-1188',
    totalDistance: 245,
    estimatedTime: 300,
    fuelCost: 58.20,
    optimized: true,
    stops: [
      { id: 'S1', address: '6801 Hollywood Blvd', city: 'Los Angeles, CA', priority: 'high', timeWindow: '08:00-09:00', packages: 2, lat: 34.1016, lng: -118.3406, status: 'completed' },
      { id: 'S2', address: '1301 Westwood Blvd', city: 'Los Angeles, CA', priority: 'medium', timeWindow: '10:00-11:00', packages: 3, lat: 34.0574, lng: -118.4427, status: 'pending' },
      { id: 'S3', address: '200 Santa Monica Pier', city: 'Santa Monica, CA', priority: 'low', timeWindow: '12:00-13:00', packages: 1, lat: 34.0083, lng: -118.4977, status: 'pending' },
    ],
  },
];
